/* @flow */
import React from 'react';

import styles from './FilterButtonGroup.module.scss';

export type FilterButtonGroupOption = {
  label: string,
  value: string | number,
};
export type FilterButtonGroupProps = {
  options: FilterButtonGroupOption[],
  value: string | number,
  onOptionClick: (option: FilterButtonGroupOption) => void,
};
export default class FilterButtonGroup extends React.PureComponent<FilterButtonGroupProps> {
  handleOptionClick = (option: FilterButtonGroupOption) => {
    if (this.props.onOptionClick) {
      this.props.onOptionClick(option);
    }
  };

  render() {
    const { options, value } = this.props;

    return (
      <div>
        <ul className={styles['chart-filters']}>
          {options.map(option => (
            <li
              key={`filter-button-group-${option.value}`}
              onClick={() => this.handleOptionClick(option)}
              className={value === option.value ? styles['filter-active'] : ''}
            >
              {option.label}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
